import type { RouteRecordRaw } from 'vue-router';

export const ordersRoute: RouteRecordRaw = {
  path: '/orders',
  name: 'Orders',
  component: () => import('./pages/OrdersPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:orders:list'),
  },
};

export const orderDetailRoute: RouteRecordRaw = {
  path: '/orders/:id',
  name: 'OrderDetail',
  component: () => import('./pages/OrderPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:orders:get'),
  },
};
